// extracted by mini-css-extract-plugin
module.exports = {"notification":"ErrorNotification_notification__1ExoH"};